<ng-container *ngIf="dataLoaded">
  <gds-heading
    [data]="{
      heading: pageLabels?.['paymentInfo.billingAddress']
    }"
    class="A2-W5"
    classes="heading-7"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-dropdown
    id="address"
    ngDefaultControl
    [data]="{
      placeholder: pageLabels?.['paymentInfo.addNewAddress'],
      label: pageLabels?.['paymentInfo.billingAddress'],
      options: gdsDropDownData,
      required: true,
      addNewLabel: pageLabels?.['paymentInfo.addNewAddress']
    }"
    [value]="primaryAddress"
    (valueChange)="onAddressChange($event)"
  >
  </gds-dropdown>
</ng-container>
